import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { Typography } from 'components/v2';

const messages = defineMessages({
  noResultsFound: {
    id: 'core.FiltersDialog.components.FilterEmptySate.FilterEmptySate.noResultsFound',
    defaultMessage: '0 results found',
  },
  helperText: {
    id: 'core.FiltersDialog.components.FilterEmptySate.FilterEmptySate.helperText',
    defaultMessage: 'Try adjusting your search to find what you’re looking for.',
  },
});

const FilterEmptyState: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Typography variant="bW600F15">{formatMessage(messages.noResultsFound)}</Typography>
      <Typography variant="inherit">{formatMessage(messages.helperText)}</Typography>
    </div>
  );
};

export default FilterEmptyState;
